<div class="muffler-container" [@smoothHeightResizeAnimation]="{
  value: heightState, params: {
    reducedHeight: reducedHeight,
    enlargedHeight: enlargedHeight
  }
}">
  <ng-content></ng-content>
</div>